module.exports = __webpack_public_path__ + "img/IMG_2532-2.b53693ce.jpg";